import styles from "./ReviewSection.module.css";

const ReviewCard = ({ review, name }) => {
  return (
    <article className={styles.reviewCard}>
      <div className={styles.stars} aria-label="5 star review">
        {Array.from({ length: 5 }).map((_, index) => (
          <span key={index}>★</span>
        ))}
      </div>
      <p className={styles.reviewText}>“{review}”</p>
      <p className={styles.reviewName}>— {name}</p>
    </article>
  );
};

export default ReviewCard;